export const emptyElement = (index, element) => ({
  index: index || 0,
  elementType: 'EMPTY_ELEMENT',
  element: element || null
});